import { render } from "./Label.vue?vue&type=template&id=8bbbee9c"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
script.render = render

export default script